// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#themeButton  svg {\n    transition: 0.6s ease;\n}", "",{"version":3,"sources":["webpack://./src/elements/theme_button/ThemeButton.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;AACzB","sourcesContent":["\n#themeButton  svg {\n    transition: 0.6s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
